import { Pipe, PipeTransform } from "@angular/core";
import { ObjectGroupViewModel } from "../../admin-panel/ObjectGroupViewModel";
import { IManagableObject } from "../../admin-panel/IManagableObject";

export class GroupFilterModel {
  public term: string;
  public group: ObjectGroupViewModel;
}


@Pipe({
    name: 'groupFilter',
    pure: false,
    standalone: false
})
export class FilterByNameAndGroupPipe implements PipeTransform
{
  transform(items: IManagableObject[], filter: GroupFilterModel): any
  {
    if (!items) return [];

    if (filter.term && filter.term != "") 
    {
      var filteredItems = [];
      let lowerCaseTerm = filter.term.toLowerCase();
      for (let i = 0; i < items.length; i++)
        if (items[i].Name.toLowerCase().indexOf(lowerCaseTerm) >= 0)
          filteredItems.push(items[i]);
        //else
          //items[i].IsChecked = false;

      items = filteredItems;
    }

    if (filter.group && filter.group.Id > 0)
    {
      let groupIDs = {};
      for (let i = 0; i < filter.group.objects.length; i++)
        groupIDs[filter.group.objects[i]] = 1;

      var filteredItems = [];
      for (let i = 0; i < items.length; i++)
        if (groupIDs[items[i].Id])
          filteredItems.push(items[i]);
        //else
          //items[i].IsChecked = false;
      return filteredItems;
    }
    return items;
  }
}
